/** Guidance wording of the additional-notes dialogs, copied verbatim from the Angular templates (ligature characters included). */

export const balanceSheetText = {
  paragraphs: [
    'If in any reporting period a micro-entity is or has been party to arrangements that are not reﬂected in its statement of ﬁnancial position and at the reporting date the risks or beneﬁts arising from those arrangements are material, the nature and business purpose of the arrangements must be given in the notes to the ﬁnancial statements to the extent necessary for enabling the ﬁnancial position of the micro-entity to be assessed. (Section 410A of the Act)',
  ],
};

export const indebtednessText = {
  paragraphs: [
    'For the aggregate of all items shown under ‘creditors’ in the small entity’s statement of ﬁnancial position there must be stated the aggregate of the following amounts: (a) the amount of any debts included under ‘creditors’ which are payable or repayable otherwise than by instalments and fall due for payment or repayment after the end of the period of ﬁve years beginning with the day next following the reporting date; and (b) in the case of any debts so included which are payable or repayable by instalments, the amount of any instalments which fall due for payment after the end of that period. In respect of each item shown under ‘creditors’ in the small entity’s statement of ﬁnancial position there must be stated the aggregate amount of any debts included under that item in respect of which any security has been given by the small entity with an indication of the nature and form of any such security.',
  ],
};

export const financialCommitText = {
  paragraphs: [
    'The total amount of any ﬁnancial commitments, guarantees and contingencies that are not included in the statement of ﬁnancial position must be stated.',
    'The total amount of any commitments concerning pensions must be separately disclosed. The total amount of any commitments which are undertaken on behalf of or for the beneﬁt of:(a) any parent, fellow subsidiary or any subsidiary of a micro- entity; or (b) any undertaking in which a micro- entity has a participating interest, An indication of the nature and form of any valuable security given by the micro- entity in respect of commitments, guarantees and contingencies .',
  ],
};

export const auditInformationText = {
  paragraphs: [
    'Audited accounts disclose information about the audit: whether the auditor’s report was unqualified, and any matter the auditor drew attention to by way of emphasis without qualifying the report (Companies Act 2006, section 495).',
  ],
};

export const limitedByGuaranteeText = {
  paragraphs: [
    'A company limited by guarantee has no share capital. Its members undertake to contribute a stated amount to the company’s assets if it is wound up. This note is added for a company limited by guarantee; edit the wording, including the amount of each member’s guarantee, to match the company’s articles.',
  ],
};

export const giftAidText = {
  title: 'Gift Aid',
  paragraphs: [
    'The FRC was made aware of significant differences in accounting treatment arising in practice in relation to the accounting for payments made, or expected to be made, by a subsidiary to its charitable parent that will qualify for gift aid (expected gift aid payments). This includes charitable parents that are exempt charities, eg they are not regulated by the Charity Commission, but have another principal regulator. Many charitable entities, including registered providers of social housing and higher education institutions, carry out trading activities through a non-charitable subsidiary. Profits from the non-charitable subsidiary might be distributed to the parent charity (or venturer in a joint venture) in a tax-efficient manner as a donation which is eligible for corporation tax relief under the gift aid rules, provided it is made during the relevant reporting period or during the following nine months.',
  ],
};

export const impairmentText = {
  title: 'Impairments of Assets',
  paragraphs: [
    'Value adjustments for impairment of fixed assets (including fixed asset investments) shall be disclosed in the notes to the financial statements if not shown separately in the income statement.',
  ],
};

export const intangibleText = {
  title: 'Intangible assets acquired in business combinations ',
  paragraphs: [
    'Fewer intangibles are required to be recognised separately from goodwill.  But separate recognition is allowed if it is providing useful information.',
  ],
};

export const eventText = {
  title: 'Event After balance Sheet Date',
  paragraphs: [
    'e nature and financial effect of material events arising after the reporting date which are not reflected in the income statement or statement of financial position must be stated.',
  ],
};

export const exceptionalText = {
  title: 'Exceptional Item',
  paragraphs: [
    'The amount and nature of any individual items of income or expenses of exceptional size or incidence must be state.',
  ],
};

export const directorText = {
  title: 'Director Loan',
  paragraphs: [
    'The director (who is also the majority shareholder) has made a loan to the business .The loan has no formal terms attached to it but has been regarded as a long-term liability in previous accounting periods. In the absence of any specific terms, this treatment is not possible under FRS 102 because loans without specific terms attached would be regarded as being repayable on demand transitional adjustment is needed to reflect the on demand feature of the loan as follows',
  ],
};
